module.exports = __webpack_public_path__ + "img/mail_icon_error.d82d9f06.svg";